class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const sectionId = this.dataset.wethemeSectionId;
    const limit = parseInt(this.dataset.productsToShow || "8", 10);
    const layout = this.dataset.layoutStyle || "slider";
    const excludeId = this.getAttribute("exclude-id"); // current product id on PDP
    const wrapper = this.closest("[data-recently-viewed-wrapper]");
    const target = this.querySelector("#recently-viewed-products");
    const key = "recently_viewed_product_ids";

    if (!wrapper || !target || !sectionId) return;

    // Load IDs
    let ids = [];
    try {
      ids = JSON.parse(localStorage.getItem(key)) || [];
    } catch (e) {
      ids = [];
    }

    // Store current product id
    if (excludeId && /^\d+$/.test(excludeId)) {
      const cur = Number(excludeId);
      if (!ids.includes(cur)) {
        ids.unshift(cur);
        ids = ids.slice(0, 30);
        localStorage.setItem(key, JSON.stringify(ids));
      }
    }

    // We don't show the current PDP inside the list
    if (excludeId) {
      ids = ids.filter((id) => String(id) !== String(excludeId));
    }

    if (!ids.length) return;

    // Build /search query with ORed product IDs (uses your Liquid search branch)
    const terms = ids.slice(0, limit).map((id) => `id:${id}`);
    const url = `/search?type=product&q=${encodeURIComponent(terms.join(" OR "))}&section_id=${sectionId}`;

    fetch(url, { credentials: "same-origin" })
      .then((r) => r.text())
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        // Pull only the inner grid that Liquid rendered for search.performed == true
        const inbound = temp.querySelector("#recently-viewed-products");
        if (!inbound) return;

        target.innerHTML = inbound.innerHTML;

        // Reveal the wrapper only if there are items
        if (target.children.length) {
          wrapper.style.display = "";

          // If the section is a slider, nudge your theme (if needed)
          if (layout === "slider") {
            document.dispatchEvent(
              new CustomEvent("theme:section:recently-viewed:init", {
                detail: { sectionId },
              })
            );
          }
        }
      })
      .catch(() => {
        /* swallow errors */
      });
  }
}

customElements.define("recently-viewed-products", RecentlyViewedProducts);
